export default __webpack_public_path__ + "static/Shopsmart3(S)-14b1290fc77f61f8277a4036d0090bb2.jpg";